"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Super/SuperTeamScreen.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _SuperTeamMembers = require('web/components/Super/SuperTeamMembers'); var _SuperTeamMembers2 = _interopRequireDefault(_SuperTeamMembers);
var _Tt = require('web/screens/Super/Tt'); var _Tt2 = _interopRequireDefault(_Tt);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _log = require('shared/log');





var _formHelpers = require('web/screens/Super/formHelpers');









const SuperTeamScreen = ({ match }) => {
  const teamKey = match.params.teamKey
  const [state, setState] = _react.useState({ status: 'loading' })
  const [modifyUsersModalOpen, setModifyUsersModalOpen] = _react.useState.call(void 0, false)

  // Loads on mount and again whenever the team key in the URL changes; the
  // route keeps this screen mounted across keys. An answer for a key the
  // screen has moved away from is ignored.
  _react.useEffect.call(void 0, () => {
    let current = true
    setState({ status: 'loading' })
    setModifyUsersModalOpen(false)
    _client2.default.send('SUPER_GetTeams', { TeamKeys: [teamKey] }).then((r) => {
      if (!current) return
      const team = _optionalChain([r, 'access', _ => _.Teams, 'optionalAccess', _2 => _2[teamKey]])
      setState(team ? { status: 'loaded', team } : { status: 'notFound' })
    }).catch((err) => {
      _log.log.error(err)
      if (current) setState({ status: 'failed', message: _formHelpers.errorMessage.call(void 0, err) })
    })
    return () => { current = false }
  }, [teamKey])

  const openModifyUsersModal = () => setModifyUsersModalOpen(true)
  const closeModifyUsersModal = _react.useCallback.call(void 0, () => setModifyUsersModalOpen(false), [])

  if (state.status === 'loading') {
    return (
      _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}, "Loading..."

      )
    )
  } else if (state.status === 'notFound') {
    return (
      _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}, "Team not found: "
           , _react2.default.createElement(_Tt2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}, teamKey)
      )
    )
  } else if (state.status === 'failed') {
    return (
      _react2.default.createElement('div', { className: "superuser--section", style: { color: 'red' }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}, "Failed to load the team: "
             , state.message
      )
    )
  }

  const team = state.team
  const members = team.Members || {}

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
        , modifyUsersModalOpen ? (
          _react2.default.createElement(SuperTeamUserModal, {
            team: team,
            open: modifyUsersModalOpen,
            onClose: closeModifyUsersModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
          )
        ) : null 
        , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}, "Properties")
        , _react2.default.createElement('dl', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
          , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}, "Team Key" )
          , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}, _react2.default.createElement(_Tt2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}, team.TeamKey))
          , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}, "Org Key" )
          , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}, _react2.default.createElement(_Tt2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}, _react2.default.createElement('a', { href: `#/super/orgs/${team.OrgKey}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}, team.OrgKey)))
          , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}, "Name")
          , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}, team.Name)
          , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}, "Deleted")
          , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}, team.Deleted ? 'yes' : 'no')
          , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}, "Created At" )
          , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}, team.CreatedAt)
          , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}, "Updated At" )
          , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}, team.UpdatedAt)
        )
      )
      , _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}
        , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}, "Members")
        ,  Object.keys(members).length > 0 ? _react2.default.createElement(_SuperTeamMembers2.default, { members: members, __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}} ) : _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}, "None") 
        , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}, _react2.default.createElement('button', { onClick: openModifyUsersModal, className: "blmh-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}, "Modify"))
      )
    )
  )
}



const addOrRemoveOptions = [
  { value: "add", label: "Add Users" },
  { value: "remove", label: "Remove Users" },
]







const SuperTeamUserModal = ({ open, onClose, team }) => {
  const [addedByKey, setAddedByKey] = _react.useState.call(void 0, '')
  const [userKeys, setUserKeys] = _react.useState([])
  const [addOrRemove, setAddOrRemove] = _react.useState('add')

  const onUserKeysChange = (val) => {
    // One key per line; blank lines and surrounding spaces are dropped.
    // SAFETY: the keys are typed in by a super user; the backend validates them.
    setUserKeys(val.split("\n").map(v => v.trim()).filter(v => v !== '') )
  }

  const onAddOrRemoveChange = (_id, _err, val) => {
    setAddOrRemove(val)
  }

  const canSend = !(addedByKey === ''
    || userKeys.length === 0
    || (addOrRemove !== 'add' && addOrRemove !== 'remove'))

  const onSubmit = () => {
    const TeamKey = team.TeamKey
    if (addOrRemove === 'add') {
      /* adding users to team */
      _client2.default.send('SuperAddUsersToTeam', {
        // SAFETY: typed in by a super user; the backend validates it.
        AddedByUserKey: addedByKey ,
        UserKeys: userKeys,
        TeamKey,
      }).then(() => {
        _log.log.info('initiated AddUsersToTeamAction')
        onClose()
      }).catch(_log.log.error)
    } else if (addOrRemove === 'remove') {
      /* adding a user */
      _client2.default.send('SuperRemoveUsersFromTeam', {
        // SAFETY: typed in by a super user; the backend validates it.
        RemovedByUserKey: addedByKey ,
        UserKeys: userKeys,
        TeamKey,
      }).then(() => {
        onClose()
        _log.log.info('initiated RemoveUsersFromTeam')
      }).catch(_log.log.error)
    } else {
      _log.log.info(`Error: addOrRemove must be 'add' or 'remove' but got:`, addOrRemove)
    }
  }

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: open,
      onClose: onClose,
      title: `Modify Team - ${team.Name}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}}

      , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 175}}, "Add users to or remove users from this team"        )
      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Modified by User Key"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}
        , _react2.default.createElement(_Form.TextInput, {
          onChange: e => setAddedByKey(e.target.value),
          placeholder: "User must be part of organization"     ,
          value: addedByKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 177}}
        )
      )
      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "User Keys" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 183}}
        , _react2.default.createElement(_Form.SimpleTextArea, {
          maxLength: undefined,
          onChange: e => onUserKeysChange(e.target.value),
          placeholder: "One UserKey per line"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 184}}
        )
      )
      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Add or Remove Users"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 190}}
        , _react2.default.createElement(_Form.RadioInput, {
          options: addOrRemoveOptions,
          onChange: onAddOrRemoveChange,
          inputId: "addOrRemove",
          value: addOrRemove, __self: this, __source: {fileName: _jsxFileName, lineNumber: 191}}
        )
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose,
        primaryBtnLabel: "Submit",
        isPrimaryEnabled: canSend,
        onPrimaryBtnClick: onSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 198}}
      )
    )
  )
}

exports. default = SuperTeamScreen
